export enum ProfileSourceFilter {
  All = 'All',
  CrmOnly = 'CrmOnly',
  PrCrm = 'PrCrm'
}
